'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n'], ['\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  box-shadow: ', ';\n  font-size: ', ';\n  height: ', ';\n  padding: 0 ', ';\n  width: 100%;\n\n  &:disabled {\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: none;\n    cursor: default;\n  }\n\n  &::placeholder {\n    font-style: italic;\n  }\n'], ['\n  ', '\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  box-shadow: ', ';\n  font-size: ', ';\n  height: ', ';\n  padding: 0 ', ';\n  width: 100%;\n\n  &:disabled {\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: none;\n    cursor: default;\n  }\n\n  &::placeholder {\n    font-style: italic;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _em = require('polished/lib/helpers/em');

var _em2 = _interopRequireDefault(_em);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputWrapper = _styledComponents2.default.div(_templateObject);

InputWrapper.displayName = 'InputWrapper';

var StyledInput = _styledComponents2.default.input(_templateObject2, (0, _mixins.InputReset)(), _config.colors.white, function (props) {
  return props.$invalid ? _config.colors.red : _config.colors.gray;
}, function (props) {
  return props.$invalid ? '0 0 0 1px ' + _config.colors.red : 'none';
}, (0, _rem2.default)('16px', _config.typography.baseFontSize), (0, _rem2.default)('40px', _config.typography.baseFontSize), (0, _em2.default)('15px', _config.typography.baseFontSize), _config.colors.gray, _config.colors.gray);

StyledInput.displayName = 'StyledInput';

/**
# Input
A basic Input.
 */

var Input = function Input(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === undefined ? false : _ref$invalid,
      id = _ref.id,
      restProps = _objectWithoutProperties(_ref, ['type', 'label', 'placeholder', 'disabled', 'invalid', 'id']);

  return _react2.default.createElement(
    InputWrapper,
    null,
    _react2.default.createElement(
      'label',
      { htmlFor: id },
      label && _react2.default.createElement(
        'span',
        null,
        label
      ),
      _react2.default.createElement(StyledInput, _extends({
        id: id,
        type: type,
        $invalid: invalid,
        placeholder: placeholder,
        disabled: disabled
      }, restProps))
    )
  );
};

Input.propTypes = {
  /** The type of Input */
  type: _propTypes2.default.string,
  /** The label for the Input */
  label: _propTypes2.default.string,
  /** Placeholder text for the Input */
  placeholder: _propTypes2.default.string,
  /** Whether the Input is disabled */
  disabled: _propTypes2.default.bool,
  /** Whether the Input is invalid */
  invalid: _propTypes2.default.bool,
  /** Mandatory ID on the input */
  id: _propTypes2.default.string.isRequired
};

Input.displayName = 'Input';

exports.default = Input;
Input.__docgenInfo = {
  'description': '# Input\r\nA basic Input.',
  'methods': [],
  'displayName': 'Input',
  'props': {
    'type': {
      'defaultValue': {
        'value': '\'text\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The type of Input'
    },
    'label': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The label for the Input'
    },
    'placeholder': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Placeholder text for the Input'
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is disabled'
    },
    'invalid': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is invalid'
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Mandatory ID on the input'
    }
  }
};